module.exports = __webpack_public_path__ + "img/access-groups.0c1d8d72.svg";